import { useLocation, useRouter } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

function RouteTracker() {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Store the previous route before it changes
      if (previousPathRef.current !== null) {
        window.sessionStorage.setItem("previousRoute", previousPathRef.current);
      }
      // Update the ref with the current path for next change
      previousPathRef.current = location.pathname + location.search;
    }
  }, [location.pathname, location.search]);

  return null;
}

export default RouteTracker;

export function usePreviousRoute() {
  return typeof window !== "undefined"
    ? window.sessionStorage.getItem("previousRoute")
    : null;
}
